

 const getTotalPriceVariant=(item,listOptions)=>{
    //console.debug('getTotalPrice, listOptions:',listOptions);
    let total=Number(item.price); 
    listOptions.forEach(opt => {
       let counter=0; 
       if(opt.price){
         counter = Number(opt.counter&& opt.counter>0 ? opt.counter:1.0)
         total+=Number(opt.price?opt.price:0.0)*counter;
         //console.debug('getTotalPrice, t:',t);
       }
    });
    //console.debug('getTotalPrice, total:',total);
    return total;
  }

 

  const getTotalOrder=(order,deliveryPrice)=>{
    let total = 0; 
    //console.log('Total', order, deliveryPrice);
    order.list.forEach(element => {
        total+= getTotalItem(element);
    });
  
    if(order.type=="delivery" && deliveryPrice && deliveryPrice.status!="out"){
          total+=deliveryPrice.normalPrice? deliveryPrice.normalPrice:0; 
          total+=deliveryPrice.extraPrice? deliveryPrice.extraPrice:0; 
    }
  
    //console.log('total', total);
    return total.toFixed(2); 
  }

  const getTotalItem = (item) =>{
    if(!item.variants || item.variants.length==0){
      return parseFloat(item.count)*parseFloat(parsePrice(item.price));
    }

    let totalItem =Number(0); 
    item.variants.forEach(variant=>{
       totalItem+=getTotalPriceVariant(item,variant.options)
    });
    return totalItem; 
}


  const parsePrice=(price)=>{
    let result =""; 
    for(let i=0; i<price.length; i++){
       let ch = price[i]; 
        if(isNumber(ch)){
          result+= ch==','?'.':ch;
        }
    }
    return result;  
  }

    
  const isNumber=(ch)=>{
    let valid = false; 
        switch(ch){
          case ',':
          case '.':
          case '0':
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '6':
          case '7':
          case '8':
          case '9': valid=true;     
        }
return valid;
}
  
  
export {
    getTotalPriceVariant, 
    getTotalOrder
}; 
